module.exports = __webpack_public_path__ + "static/media/magnet.70a5dcc5.svg";